import React from 'react';
import { FieldValues, FormProvider, UseFormReturn } from 'react-hook-form';
import { Box } from '@fiverr-private/theme';
import { FormProps } from './types';

const Form = <TFormValues extends FieldValues>({
  children,
  methods,
  onSubmit,
  width = '100%',
  gap = '6',
  dataTrackTag = 'form',
  ...restProps
}: FormProps<TFormValues>) => (
  <FormProvider {...(methods as UseFormReturn<TFormValues>)}>
    <Box
      as="form"
      display="flex"
      direction="column"
      gap={gap}
      width={width}
      {...(onSubmit ? { onSubmit: methods?.handleSubmit(onSubmit) } : {})}
      {...restProps}
      dataTrackTag={dataTrackTag}
    >
      {children}
    </Box>
  </FormProvider>
);

Form.displayName = 'Form';
export default Form;
